import { useState } from "react";
import { Button } from "@/components/ui/button";
import OdooBooking from "@/components/OdooBooking";
import { Phone, Mail, MessageCircle, Calendar, X } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

export const StickyContactBar = ({ onOpenLeadForm, verticalId, verticalName }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);

  if (isDismissed) return null;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ y: 100, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        exit={{ y: 100, opacity: 0 }}
        className="fixed bottom-0 left-0 right-0 z-40"
        data-testid="sticky-contact-bar"
      >
        {/* Main Bar */}
        <div className="bg-gradient-to-r from-[#0066CC] to-[#0052A3] shadow-lg border-t border-blue-400/20">
          <div className="max-w-6xl mx-auto px-4 py-3">
            <div className="flex items-center justify-between gap-4">
              {/* Left: Message */}
              <div className="hidden sm:flex items-center gap-3 text-white">
                <div className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center">
                  <MessageCircle className="w-5 h-5" />
                </div>
                <div>
                  <p className="font-semibold text-sm">Need Help Deciding?</p>
                  <p className="text-xs text-blue-100">Talk to our solution experts - It's free!</p>
                </div>
              </div>

              {/* Center/Right: Action Buttons */}
              <div className="flex items-center gap-2 flex-1 sm:flex-none justify-center sm:justify-end">
                {/* Mobile Toggle */}
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={() => setIsExpanded(!isExpanded)}
                  className="sm:hidden text-white hover:bg-white/10"
                  data-testid="expand-contact-options"
                >
                  {isExpanded ? "Less Options" : "Contact Us"}
                </Button>

                {/* Desktop Buttons */}
                <div className={`${isExpanded ? 'flex' : 'hidden'} sm:flex items-center gap-2`}>
                  <a href="tel:+918297555678">
                    <Button
                      size="sm"
                      variant="secondary"
                      className="bg-white/10 text-white hover:bg-white/20 border-0 gap-2"
                      data-testid="call-now-btn"
                    >
                      <Phone className="w-4 h-4" />
                      <span className="hidden md:inline">+91 829 755 5678</span>
                      <span className="md:hidden">Call</span>
                    </Button>
                  </a>
                  
                  <a href="mailto:info@absolinsoft.com">
                    <Button
                      size="sm"
                      variant="secondary"
                      className="bg-white/10 text-white hover:bg-white/20 border-0 gap-2"
                      data-testid="email-btn"
                    >
                      <Mail className="w-4 h-4" />
                      <span className="hidden md:inline">Email Us</span>
                      <span className="md:hidden">Email</span>
                    </Button>
                  </a>
                  
                  <OdooBooking
                    verticalId={verticalId || ""}
                    verticalName={verticalName || ""}
                    buttonText="Schedule Free Demo"
                    buttonSize="sm"
                    buttonClassName="bg-white text-[#0066CC] hover:bg-blue-50 gap-2 font-semibold hidden md:flex"
                  />
                  <OdooBooking
                    verticalId={verticalId || ""}
                    verticalName={verticalName || ""}
                    buttonText="Demo"
                    buttonSize="sm"
                    buttonClassName="bg-white text-[#0066CC] hover:bg-blue-50 gap-2 font-semibold md:hidden"
                  />
                </div>

                {/* Dismiss Button */}
                <Button
                  variant="ghost"
                  size="icon"
                  onClick={() => setIsDismissed(true)}
                  className="text-white/70 hover:text-white hover:bg-white/10 h-8 w-8"
                  data-testid="dismiss-contact-bar"
                >
                  <X className="w-4 h-4" />
                </Button>
              </div>
            </div>
          </div>
        </div>
      </motion.div>
    </AnimatePresence>
  );
};
